import { Tooltip, TooltipProps } from '@/lib/core/components/Tooltip'

export type TruncateProps = {
  content: string | null | undefined
  limit?: number
  tooltip?: Partial<TooltipProps>
  placement?: TooltipProps['placement']
}

export const Truncate = ({ content, limit = 30, tooltip = {}, placement }: TruncateProps) =>
  content && content.length > limit ? (
    <Tooltip
      contentPadding={2}
      placement={placement ?? 'top'}
      tooltipContent={<p>{content}</p>}
      {...tooltip}
    >
      <span>
        {content.slice(0, limit)}
        ...
      </span>
    </Tooltip>
  ) : (
    <>{content}</>
  )
